import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'isEvery',
  standalone: true
})
export class IsEveryPipe implements PipeTransform {
  transform(items: any[], key: string): boolean {
    if (!key || !items?.length) return false;
    return items.every(item => item[key]);
  }
}
